import inzolLogo from './../../../assets/inzolLogos/logo.svg'

export default function Spinner() {
  return (
    <div
      id="spinner"
      className="display-none"
      role="status"
      aria-live="polite"
      aria-label="Cargando experiencia Inzol"
    >
      <img src={inzolLogo} alt="Logo Inzol animado" className="spinner-logo" />
    </div>
  )
}
